import MapView from '@/components/map/MapView'

export default function MapPage() {
  return (
    <div className="h-[calc(100vh-4rem)] w-full relative">
      <MapView />
    </div>
  )
}
